import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=3000ec20"
import script from "./Install.vue?vue&type=script&lang=js"
export * from "./Install.vue?vue&type=script&lang=js"
import style0 from "./Install.vue?vue&type=style&index=0&id=3000ec20&prod&lang=scss"
import style1 from "./Install.vue?vue&type=style&index=1&id=3000ec20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports